const SmoothScroll = (top, behavior) => {
  window.scrollTo({
    top: top,
    behavior: `${behavior}`,
  });
};

export { SmoothScroll };
